module.exports = __webpack_public_path__ + "img/asset_USDT.5f790078.svg";